// extracted by mini-css-extract-plugin
export default {"title":"Welcome_title__LOVru","titleMobile":"Welcome_titleMobile__MS0jt","logo":"Welcome_logo__gnS4d","cta":"Welcome_cta__YaDhZ","submitBtn":"Welcome_submitBtn__JK685"};